import { ColorsList } from '../core/utils/type-colors';

export const ecuScanner = 65535;
export const ecuIsNotScannerMsg = 'La ECU de esta variable no es Scanner';
export const variableGroupDevicesInfo = 'Los dispositivos G28, Sinotrack y Quecklink no van a ser afectados por grupos de variables'; 

export const overchargedTrackingColor = ColorsList.dark_blue;

export const acopladoKey = 'variable_report_attached_truck'

export const ecuIsScanner = (ecuAddress: number) => {
    if(ecuAddress == ecuScanner){
        return true
    }
    return false
}

export enum SlotTypes {
    FixedLengthASCII = '0',
    DelimitedASCII = '1',
    MultiplePartsASCII = '2',
    State = '3',
    UnsignedShort = '4',
    SignedShort = '5',
    UnsignedInt = '6',
    SignedInt = '7',
    Decimal = '8',
    DelimitedASCIIToDecimal = '9',
    DoubleDecimal = '10'
}

export enum ProtocolIds {
    ISO14230 = 0,
    ISO15765 = 1,
    J1939 = 2,
    J1587 = 4,
    SERIAL = 5,
    CAN = 6
}

export const getHexadecimalValue = (value) => {
    let number = parseInt(value);
    if (isNaN(number)) {
        return '';
    }

    return '0x' + number.toString(16);
}
